export interface YarnSpecReport {
  key: string;
  count: number;
  twistTurns: number;
  decitexCountOverride: number;
  resultantCount: number;
  ply: number;
  twistWastePercent: number;
  colourDescription: string;
  countSystemDescription: string;
  comments: string;
  countDescription: string;
  micron: string;
  twistDescription: string;
}
